export const plusIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 27.096 27.096"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_2"
          data-name="Rectangle 2"
          width="27.096"
          height="27.096"
          transform="translate(0 0)"
          fill="none"
        />
      </clipPath>
    </defs>
    <g
      id="Group_2"
      data-name="Group 2"
      transform="translate(0 0)"
      clip-path="url(#clip-path)"
    >
      <path
        id="Path_2"
        data-name="Path 2"
        d="M27.1,13.548A13.548,13.548,0,1,1,13.548,0,13.548,13.548,0,0,1,27.1,13.548m-6.818-1.475a.873.873,0,0,0-.641-.213H15.215V7.437A.872.872,0,0,0,15,6.8a.873.873,0,0,0-.641-.213H12.736a.869.869,0,0,0-.64.213.867.867,0,0,0-.214.642V11.86H7.459a.876.876,0,0,0-.642.213.875.875,0,0,0-.213.641v1.624a.873.873,0,0,0,.213.641.872.872,0,0,0,.642.214h4.423v4.423a.756.756,0,0,0,.854.854H14.36a.756.756,0,0,0,.855-.854V15.193h4.422a.756.756,0,0,0,.855-.855V12.714a.875.875,0,0,0-.214-.641"
        fill="#fff"
      />
    </g>
  </svg>
);
